import React, { Component } from "react";
import BtnButton from "../../components/forms/elements/BtnButton";
import FormTelegramVinculo from "./FormTelegramVinculo";

/**
 * Convite exibido no login para quem ainda não vinculou o Telegram.
 *
 * Quem decide se aparece é o Layout (uma vez a cada 7 dias, por usuário).
 *
 * As duas etapas (convite e QR Code) vivem no MESMO modal, por state local. Trocar
 * de modal aqui não funciona: o ModalContainer usa o índice do array como key e o
 * ModalForm só lê as props no construtor, então fechar um e abrir outro no mesmo
 * ciclo faz o React reaproveitar a instância antiga - que acabou de ser marcada
 * como {show: false, form: null} - e nada aparece na tela.
 */
export default class FormTelegramConvite extends Component {

    constructor(props) {
        super(props);
        this.handleVincular = this.handleVincular.bind(this);
        this.state = { flVincular: false };
    }

    handleVincular() {
        this.setState({ flVincular: true });
    }

    render() {

        //onSave/onClose vêm do ModalForm e são repassados: concluir ou cancelar o
        //vínculo fecha o modal inteiro, sem voltar para o convite
        if (this.state.flVincular) {
            return <FormTelegramVinculo {...this.props} />;
        }

        return this.getRenderConvite();
    }

    getRenderConvite() {
        return (
            <div>
                <div className="text-center mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="#229ED9" className="bi bi-telegram" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                    </svg>
                </div>

                <h5 className="text-center mb-3">Receba os avisos do sistema no Telegram</h5>

                <p>
                    Os avisos que você já recebe passam a chegar também no seu Telegram — incluindo o
                    <strong> texto dos comentários das ordens e os arquivos anexados</strong>, direto no celular.
                </p>

                <p className="mb-3">
                    É rápido: basta ler um QR Code com a câmera. Leva menos de um minuto e você só precisa
                    ter o <strong>Telegram instalado</strong> no celular.
                </p>

                <div className="alert alert-light border py-2 mb-4">
                    <small className="text-muted">
                        Depois de vincular, dá para escolher exatamente quais avisos quer receber por lá,
                        em <em>Atualização de Dados do Usuário</em>, aba <em>Avisos</em>.
                    </small>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <BtnButton className="btn-outline-secondary" onClick={this.props.onClose}>
                        Agora não
                    </BtnButton>
                    <BtnButton className="btn-primary" onClick={this.handleVincular}>
                        Vincular agora
                    </BtnButton>
                </div>
            </div>
        );
    }
}
